import { shouldLogOutOnForbidden } from '@/lib/api/twoFactorEnrollment';
import { generalApi } from '@/lib/api/general';
import {
  dispatchCheckApiError,
  dispatchLogOut,
  MainContext,
} from '../actionsMain';
import { AxiosError } from 'axios';
import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';
import { UpdatePasswordSettingRequest } from '@/interfaces/api/general/company';
import { commitAddNotification } from '../mutations';
import { defineMessages } from '@/lib/i18n';

const m = defineMessages({
  savePasswordSetting: 'パスワード設定を保存しました',
});

export const actionGetCompanyPasswordSetting = async (
  context: MainContext,
  payload: {
    companyId: string;
  }
) => {
  try {
    return await generalApi.getPasswordSetting(payload.companyId);
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};

export const actionUpdateCompanyPasswordSetting = async (
  context: MainContext,
  payload: {
    companyId: string;
    data: UpdatePasswordSettingRequest;
  }
) => {
  try {
    await generalApi.updatePasswordSetting(payload.companyId, payload.data);

    commitAddNotification(context, {
      messageKey: m.savePasswordSetting,
      color: 'success',
    });
  } catch (error) {
    const axiosError = error as AxiosError<ApiErrorResponse>;
    await dispatchCheckApiError(context, axiosError);
    if (shouldLogOutOnForbidden(axiosError)) {
      await dispatchLogOut(context);
    }
    throw axiosError;
  }
};
